import { createWireTransferUploadSlipContainer } from './container'
import { WireTransferUploadSlip as WireTransferUploadSlipUI } from './ui/wire-transfer-upload-slip'

export const WireTransferUploadSlip = createWireTransferUploadSlipContainer(WireTransferUploadSlipUI)
